/* -----------------Child components--------------- */
import AccountListItem from "./AccountListItem";

/* -----------------Types--------------- */
import Box from "@memorang/ui/src/components/Box";
import ScrollContainer from "@memorang/ui/src/components/ScrollContainer";
import { Card } from "react-native-paper";
import type { FontSchemaType } from "../../types";
import { useDevice } from "../../useDevice";
import CustomNavigationBar from "../CustomAppbar";
import type { CustomNavigationBarProps } from "../CustomAppbar/types";
import { CustomListSubheader } from "../CustomListSubheader";
import type { Section } from "./types";

type Props = {
	sections: Section[];
	showPoweredBy?: boolean;
	font: FontSchemaType;
	isDarkMode: boolean;
	showAudioPlaybackTestDialog: boolean;
	accountExtendValidity: string;
	hasMoreThanOneExam?: boolean;
	toggleDarkMode: () => void;
	PoweredBy?: () => React.ReactNode;
	toggleAudioPlaybackTestDialog: () => void;
	handleNavigateToExamsRoute: () => void;
	customAppBar: CustomNavigationBarProps;
};

const AccountSettingsApplet = ({
	sections,
	showPoweredBy,
	customAppBar,
	font,
	isDarkMode,
	showAudioPlaybackTestDialog,
	accountExtendValidity,
	hasMoreThanOneExam,
	toggleDarkMode,
	toggleAudioPlaybackTestDialog,
	PoweredBy,
	handleNavigateToExamsRoute,
}: Props) => {
	const { isMobile } = useDevice();

	const Wrapper = isMobile ? Box : Card;

	return (
		<>
			<CustomNavigationBar
				mode={isMobile ? "small" : "medium"}
				align={customAppBar.align ?? "flex-start"}
				options={{
					headerTitle: customAppBar.options?.headerTitle,
					subtitle: customAppBar.options?.subtitle,
					headerRight: customAppBar.options?.headerRight,
					headerLeft: customAppBar.options?.headerLeft,
				}}
				onBackPress={customAppBar.onBackPress}
				back={customAppBar.back}
				accessible
				accessibilityLabel={customAppBar.accessibilityLabel}
			/>
			<ScrollContainer maxWidth="sm">
				<Wrapper
					style={{
						marginVertical: 16,
					}}
				>
					<Box gap={16} paddingTop={16}>
						{sections.map(({ sectionTitle, items }) => (
							<Box key={sectionTitle} gap={8}>
								<CustomListSubheader
									style={{
										paddingLeft: 16,
									}}
									font={font}
								>
									{sectionTitle}
								</CustomListSubheader>
								{items.map((view) => (
									<AccountListItem
										key={view.title}
										{...view}
										isDarkMode={isDarkMode}
										showAudioPlaybackTestDialog={showAudioPlaybackTestDialog}
										accountExtendValidity={accountExtendValidity}
										hasMoreThanOneExam={hasMoreThanOneExam}
										toggleDarkMode={toggleDarkMode}
										toggleAudioPlaybackTestDialog={
											toggleAudioPlaybackTestDialog
										}
										handleNavigateToExamsRoute={handleNavigateToExamsRoute}
									/>
								))}
							</Box>
						))}
					</Box>
					{showPoweredBy && PoweredBy && <PoweredBy />}
				</Wrapper>
			</ScrollContainer>
		</>
	);
};

export default AccountSettingsApplet;
